// Application route path information
const RoutePaths = {
  HOME: '/',
  LOGIN: '/login',
  AGENTS: '/cluevault',
  TEAM: '/team',
  ZONES: '/zones',
  STATE_CODES: '/state-codes',
  ZIPCODES: '/zipcodes',
  LOGOUT: '/logout',
  UPDATE_PROFILE: '/manage-profile',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  CHANGE_PASSWORD: '/change-password',
  INVITATION: '/invitation/:token',
  CONTRACT: '/contract/:token',
  CONTRACT_SIGNED: '/:token/signed',
  CONTRACT_CANCELLED: '/:token/cancelled',
  CONTRACT_PAYMENT: '/:token/payment',
  RESOURCES: '/resources',
  BILLING: '/account/:page',
  AD_APPROVALS: '/approvals/ads',
  NRP_DASHBOARD: '/dashboard',
  ADMIN_RESOURCE: '/manage-resources',
  TV_SHOW: '/tv-show',
  PARTICIPATION: '/participation',
  CONTENT: '/content',
  RESOURCES_ARCHIVE_SUCCESS_CALLS: '/resources/success-calls',
};

export default RoutePaths;
